import { render, staticRenderFns } from "./LibraryRedesignBanner.vue?vue&type=template&id=2226ecac&scoped=true"
import script from "./LibraryRedesignBanner.vue?vue&type=script&lang=js"
export * from "./LibraryRedesignBanner.vue?vue&type=script&lang=js"
import style0 from "./LibraryRedesignBanner.vue?vue&type=style&index=0&id=2226ecac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226ecac",
  null
  
)

export default component.exports